/* Glow mode (mobile): bulb toggle + instructions poster. See sections/dw-glow-toggle.liquid */
(() => {
  const root = document.querySelector('.dw-glow');
  if (!root) return;

  const images = window.DW_GLOW_IMAGES || {};
  const labels = window.DW_GLOW_LABELS || {};
  const toggle = root.querySelector('[data-glow-toggle]');
  const label = root.querySelector('[data-glow-label]');
  const modal = document.querySelector('[data-glow-modal]');
  const KEY = 'dw_glow_on';

  // Keep the modal outside any transformed ancestor
  if (modal) document.body.appendChild(modal);

  const handleOf = (a) => {
    const m = (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  };

  // Lay the glowing cutout over each product card's photo
  function decorate(scope) {
    (scope || document).querySelectorAll('.card__media').forEach((media) => {
      if (media.querySelector('.dw-glow-img, .dw-glow-fallback')) return;
      const link = media.closest('a[href*="/products/"]') || media.parentElement.querySelector('a[href*="/products/"]');
      const handle = link && handleOf(link);
      const box = media.querySelector('.media') || media;
      if (handle && images[handle]) {
        const img = document.createElement('img');
        img.className = 'dw-glow-img';
        img.src = images[handle];
        img.alt = '';
        img.loading = 'lazy';
        img.decoding = 'async';
        box.appendChild(img);
      } else {
        box.classList.add('dw-glow-fallback');
      }
    });
  }

  let observer;
  function setOn(on) {
    document.body.classList.toggle('dw-glow-on', on);
    toggle.setAttribute('aria-pressed', String(on));
    label.textContent = on ? labels.on : labels.off;
    try {
      sessionStorage.setItem(KEY, on ? '1' : '0');
    } catch (e) {}
    if (!on) {
      // Back to normal: drop the glowing overlays entirely
      document.querySelectorAll('.dw-glow-img').forEach((img) => img.remove());
      document.querySelectorAll('.dw-glow-fallback').forEach((el) => el.classList.remove('dw-glow-fallback'));
    }
    if (on) {
      decorate();
      // Cards added later (filters, "load more") get decorated too
      if (!observer) {
        observer = new MutationObserver(() => document.body.classList.contains('dw-glow-on') && decorate());
        observer.observe(document.querySelector('main') || document.body, { childList: true, subtree: true });
      }
    }
  }

  toggle.addEventListener('click', () => {
    const on = !document.body.classList.contains('dw-glow-on');
    try { if (window.mzEmit) window.mzEmit('glow:toggle', { value: on ? 'on' : 'off' }); } catch (e) {}
    setOn(on);
  });

  // Instructions poster
  function openModal() {
    modal.hidden = false;
    requestAnimationFrame(() => modal.classList.add('is-open'));
    document.body.classList.add('dw-glow-modal-open');
  }
  function closeModal() {
    modal.classList.remove('is-open');
    document.body.classList.remove('dw-glow-modal-open');
    setTimeout(() => (modal.hidden = true), 200);
  }
  root.querySelector('[data-glow-help]').addEventListener('click', () => {
    try { if (window.mzEmit) window.mzEmit('glow:help', {}); } catch (e) {}
    openModal();
  });
  modal.addEventListener('click', closeModal);
  document.addEventListener('keydown', (e) => e.key === 'Escape' && !modal.hidden && closeModal());

  try {
    if (sessionStorage.getItem(KEY) === '1') setOn(true);
  } catch (e) {}
})();
